import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TarActionItemCode } from '@ekhodealer/ekho-common';

import type { CompleteWarrantyRegistrationResponse } from '@ekhodealer/ekho-common';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { apiClient } from '@config/server/apiClient';
import { ordersEndpoints } from '@config/server/apiEndpoints';

import { updateProgressCache } from './progressCacheUtils';


export const completeWarrantyRegistration = async (
	servicesProviderId: string,
	orderId: string,
): Promise<CompleteWarrantyRegistrationResponse> => {
	const response = await apiClient.post<CompleteWarrantyRegistrationResponse>(
		ordersEndpoints.completeWarrantyRegistration(servicesProviderId, orderId),
		{}, // Empty body as per backend schema
	);
	return response.data;
};

export const useCompleteWarrantyRegistration = (orderId: string | undefined) => {
	const servicesProviderId = useCurrentServicesProviderId();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async () => {
			if (!orderId || !servicesProviderId) {
				throw new Error(
					'Unable to complete warranty registration without an order ID or services provider ID.',
				);
			}

			return completeWarrantyRegistration(servicesProviderId, orderId);
		},
		onSuccess: (data) => {
			if (!orderId || !servicesProviderId) return;
			updateProgressCache(queryClient, servicesProviderId, orderId, data.progress, TarActionItemCode.COMPLETE_WARRANTY_REGISTRATION);
		},
	});
};
